import React from 'react';

interface PCMaxWidthContainerProps {
  children: React.ReactNode;
  maxWidth?: string;
  bgGradient?: string;
}

const PCMaxWidthContainer: React.FC<PCMaxWidthContainerProps> = ({
  children,
  maxWidth = '800px',
  bgGradient = 'bg-gradient-to-b from-[#f8f9ff] to-[#ffffff]'
}) => {
  return (
    <div className={`min-h-screen ${bgGradient}`}>
      <div className='mx-auto' style={{ maxWidth }}>
        {children}
      </div>
    </div>
  );
};

export default PCMaxWidthContainer;
